import React, {Component, PropTypes} from 'react'
import {connect} from 'react-redux'
import {ButtonToolbar, Input} from 'react-bootstrap'
import LoaderButton from '../../core/components/LoaderButton'
import Card from '../../core/components/Card'
import {sendAcceptInterventionCmd, sendRefuseInterventionCmd, loadTicket, chooseIfSendNotificationWhenInterventionAccepted} from '../actions'
import i18n from '../i18n'

import SendInterventionInfoToAssignee from './SendInterventionInfoToAssignee'

class AcceptRefuseInterventionCard extends Component {
    static propTypes = {
    }

    _sendAcceptCmd() {
        const {dispatch} = this.props

        return dispatch(sendAcceptInterventionCmd()).then(() => {
            return dispatch(loadTicket())
        })
    }

    _sendRefuseCmd() {
        const {dispatch} = this.props
        
        return dispatch(sendRefuseInterventionCmd()).then(() => {
            return dispatch(loadTicket())
        })
    }

    emailStuff = () => {
        const {assignee} = this.props
        return <SendInterventionInfoToAssignee assignee={assignee} />
    }

    render() {
        const {dispatch, acceptInterventionCmd, ...others} = this.props
        const {accepted} = acceptInterventionCmd

        const header = (
            <h5>{i18n.interventionAcceptation}</h5>
        )

        return (
            <div>
                <Card
                    header={header}
                    {...others}>
                    {this.emailStuff()}
                    <ButtonToolbar>
                        <LoaderButton
                            bsStyle='primary'
                            bsSize='large'
                            disabled={!accepted}
                            onClick={(e) => this._sendAcceptCmd(e)}>
                            {i18n.acceptIntervention}
                        </LoaderButton>
                        <LoaderButton
                            bsStyle='danger'
                            bsSize='large'
                            onClick={(e) => this._sendRefuseCmd(e)}>
                            {i18n.refuseIntervention}
                        </LoaderButton>
                    </ButtonToolbar>
                </Card>
            </div>
        )
    }
}

AcceptRefuseInterventionCard = connect(({ticket}) => {
    const {acceptInterventionCmd} = ticket
    return {acceptInterventionCmd}
})(AcceptRefuseInterventionCard)

export default AcceptRefuseInterventionCard


// WEBPACK FOOTER //
// ./lib/ticket/components/AcceptRefuseInterventionCard.js